/**
 * Mirrors backend Analytics::PrepareId (`envPrefix.slice(0, 20) + '_' + dbId`).
 */
const ALREADY_PREPARED_REGEX = /^[^_=]{1,20}_\d+$/;

const envPrefix = (analyticsEnvironment: string): string =>
  analyticsEnvironment.trim().slice(0, 20);

export const normalizeTreatmentPlanIdForAnalytics = (
  raw: string | undefined | null,
  analyticsEnvironment: string | undefined | null
): string | undefined | null => {
  if (raw === undefined || raw === null) return raw;

  const trimmed = raw.trim();

  if (trimmed === "") return raw;

  const env = analyticsEnvironment?.trim();

  if (!env) return raw;

  if (ALREADY_PREPARED_REGEX.test(trimmed)) return trimmed;

  try {
    const dbId = atob(trimmed).split("-").pop() ?? "";

    if (!/^\d+$/.test(dbId)) return raw;

    return `${envPrefix(env)}_${dbId}`;
  } catch {
    return raw;
  }
};

export const normalizeTreatmentPlanIdInFsAnalyticsPayload = <T extends Record<string, unknown>>(
  payload: T,
  analyticsEnvironment: string | undefined | null
): T => {
  const env = analyticsEnvironment?.trim();

  if (
    !env ||
    !Object.prototype.hasOwnProperty.call(payload, "treatment_plan_id") ||
    typeof payload.treatment_plan_id !== "string"
  ) {
    return payload;
  }

  const normalized = normalizeTreatmentPlanIdForAnalytics(payload.treatment_plan_id, env);

  return normalized === payload.treatment_plan_id
    ? payload
    : { ...payload, treatment_plan_id: normalized };
};
